




























































import Vue, { PropType } from 'vue';

import { isDragEvent } from '@/utilities/guards';
import { DocumentImage, DynamicDocumentItem } from '@/types';
import documentCtxMixin from '@/containers/dynamic-document/document-ctx';
import GridItem from './GridItem.vue';

type ImageValue = string | DocumentImage;

export default documentCtxMixin.extend({
  props: {
    value: {
      type: Array as PropType<ImageValue[]>,
      default: () => [],
    },
    editable: Boolean,
    // The field being rendered — passed to the injected persistence handlers
    // (e.g. to read item.meta.slot) when a host overrides the upload path.
    item: {
      type: Object as PropType<DynamicDocumentItem>,
      default: undefined,
    },
  },

  components: {
    GridItem,
  },

  computed: {
    items(): Partial<DocumentImage>[] {
      return this.value.map(entry => {
        // Persisted backend Document (service flow) — carries its own url/id,
        // not tracked by the library cache.
        if (typeof entry !== 'string') {
          return entry;
        }

        // Library-cache URL (installation flow) — status comes from the store.
        return {
          url: entry,
          media: this.$store.getters['library/findItem'](entry),
          serverStatus: this.$store.getters['library/serverStatus'](entry),
          isSyncing: this.$store.getters['library/isItemSyncing'](entry),
        };
      });
    },
  },

  data() {
    return {
      showOptions: false,
      mode: 'file' as 'file' | 'camera',
    };
  },

  methods: {
    selectFiles() {
      (this.$refs.file as HTMLInputElement).click();
      this.mode = 'file';
      this.showOptions = false;
    },

    openCamera() {
      (this.$refs.camera as HTMLInputElement).click();
      this.mode = 'camera';
      this.showOptions = false;
    },

    onFileChange(e: Event | DragEvent) {
      let files: FileList | undefined | null;

      if (isDragEvent(e)) {
        files = e.dataTransfer?.files;
      } else {
        files = (e.target as HTMLInputElement).files;
      }

      if (files) {
        this.uploadFiles([...files]);
      }
    },

    async uploadFiles(files: File[]) {
      if (!files.length) {
        return;
      }

      const file = files.shift() as File;

      if (this.ctx.uploadPhoto) {
        // Host-provided path: upload immediately, append the persisted Document.
        const image = await this.ctx.uploadPhoto(file, this.item);
        this.$emit('input', [...this.value, image]);
      } else {
        // Default library-cache path (installation flow).
        const url =
          this.mode === 'file'
            ? await this.$store.dispatch('library/addFile', file)
            : await this.$store.dispatch('library/addPhoto', file);

        this.$emit('input', [...this.value, url]);
      }

      this.uploadFiles(files);
    },

    async removeImage(image: Partial<DocumentImage>) {
      if (this.ctx.removePhoto) {
        await this.ctx.removePhoto(image as DocumentImage, this.item);
      }

      const images = this.value.filter(entry => {
        if (typeof entry === 'string') {
          return entry !== image.url;
        }

        return image.id != null ? entry.id !== image.id : entry.url !== image.url;
      });

      this.$emit('input', images);
    },
  },
});
